<template>
  <div v-if="carregaModel">
    <v-row class="d-flex justify-center">
      <v-card-title class="text-h5 primary--text">
        Resultado da Consulta
      </v-card-title>
    </v-row>
    <v-row class="justify-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-3 mb-3"
            v-bind="attrs"
            v-on="on"
            depressed
            color="primary"
            @click="exportaBureau"
            data-cy="exportarPDF"
          >
            <v-icon>ph-file-pdf</v-icon>
          </v-btn>
        </template>
        <span>Exportar PDF</span>
      </v-tooltip>
    </v-row>
    <v-card-text>
      <span class="text-h5 ml-3 primary--text">
        Informações Referente ao Email
      </span>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">E-mail</v-row>
          <v-row class="text-subtitle">{{ model.Email }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Nome</v-row>
          <v-row class="text-subtitle">{{ model.Nome }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Gênero</v-row>
          <v-row class="text-subtitle">{{ model.Genero }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5" v-if="model.EmailExiste">
          <v-row class="text-subtitle">País</v-row>
          <v-row class="text-subtitle">{{ model.Pais }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">E-mail Existe</v-row>
          <v-row class="text-subtitle">{{ model.EmailExiste ? 'Sim' : 'Não' }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Score</v-row>
          <v-row class="text-subtitle">{{ model.Score }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Recomendação</v-row>
          <v-row class="text-subtitle">{{ model.Recomendacao }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Risco</v-row>
          <v-row class="text-subtitle">{{ model.Risco }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Faixa de Risco</v-row>
          <v-row class="text-subtitle">{{ model.FaixaRisco }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Status</v-row>
          <v-row class="text-subtitle">{{ model.Status }}</v-row>
        </v-col>
        <template v-if="model.Status === 'Verified'">
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Primeira Verificação feita em</v-row>
            <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.DtPrimVerificacao) }}</v-row>
          </v-col>
          <v-col cols="4" class="mt-3 mb-5">
            <v-row class="text-subtitle">Última Verificação feita em</v-row>
            <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.DtUltVerificacao) }}</v-row>
          </v-col>
        </template>
      </v-row>
      <span class="text-h5 ml-3 primary--text"
        >Informações Referente ao Domínio</span
      >
      <v-divider></v-divider>
      <v-row>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Domínio</v-row>
          <v-row class="text-subtitle">{{ model.Dominio }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Empresa</v-row>
          <v-row class="text-subtitle">{{ model.DominioEmpresa }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5" v-if="model.DominioExiste">
          <v-row class="text-subtitle">País</v-row>
          <v-row class="text-subtitle">{{ model.DominioPais }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Domínio Existe</v-row>
          <v-row class="text-subtitle">{{ model.DominioExiste ? 'Sim' : 'Não' }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5" v-if="model.DominioExiste">
          <v-row class="text-subtitle">Domínio Criado em</v-row>
          <v-row class="text-subtitle">{{ $api.UI.Format.Date(model.DominioDtCriacao) }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Risco</v-row>
          <v-row class="text-subtitle">{{ model.DominioRisco }}</v-row>
        </v-col>
        <v-col cols="4" class="mt-3 mb-5">
          <v-row class="text-subtitle">Informação Relevante</v-row>
          <v-row class="text-subtitle">{{ model.DominioInfo }}</v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model: {},
      carregaModel: false,
    };
  },
  methods: {
    ConsultaEmailAge (email) {
      const th = this;

      const dto = {
        consulta: {
          Email: email,
        },
      };

      th.$api.Multiplo.Post('ConsultaEmailAge', dto).then((response) => {
        if (th.$api.UI.PostLoadData(response.JSON)) {
          const result = JSON.parse(response.JSON);
          if (Object.keys(result).length > 0) {
            const obj = {
              Email: result[0].email,
              Nome: result[0].namematch || '---',
              Genero: result[0].gender || '---',
              Pais: result[0].country,
              EmailExiste: result[0].emailExists === 'Yes',
              Score: result[0].EAScore,
              Recomendacao: result[0].EAAdvice,
              Risco: result[0].fraudRisk,
              FaixaRisco: result[0].EARiskBand,
              Status: result[0].status,
              DtPrimVerificacao: result[0].firstVerificationDate,
              DtUltVerificacao: result[0].lastVerificationDate,
              Dominio: result[0].domainname,
              DominioEmpresa: result[0].domaincompany || '---',
              DominioPais: result[0].domaincountryname,
              DominioExiste: result[0].domainExists === 'Yes',
              DominioDtCriacao: result[0].domainAge,
              DominioRisco: result[0].domainrisklevel,
              DominioInfo: result[0].domainrelevantinfo,
            }
            th.$set(th, 'model', obj);
            th.carregaModel = true;
          } else if (response.HasError || response.Falha) {
            th.$api.UI.ShowError('Erro', response.Msg);
          } else {
            th.$api.UI.ShowError('Erro', 'E-mail inválido.');
          }
        }
      });
    },
    exportaBureau (tipo) {
      const th = this
      var dto = {
        ...th.model
      }
      th.$api.Bureau.GerarPDFEmailAge(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.downloadBureau(response.data, tipo)
        }
      })
    },
    downloadBureau (file, tipo) {
      var nomeArquivo = 'EmailAge - ' + this.model.Email + '.pdf'
      var blob = tipo === 1 ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' }) : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    }
  },
};
</script>
